const userLocale = typeof navigator !== 'undefined' ? navigator.language : 'en-US';
const numberFormatter = new Intl.NumberFormat(userLocale, {
  minimumFractionDigits: 2,
  maximumFractionDigits: 5
});

const getOptionName = (price: string | number, parentName: string): string => {
  const priceNumber = Number(price);
  if (Number.isNaN(priceNumber)) {
    return `- ${parentName}`;
  }

  const roundedPrice = numberFormatter.format(parseFloat(priceNumber.toFixed(5)));
  return `${roundedPrice} ${parentName}`;
};

export const getOptionLedgerSecurityName = (
  ledgerRows: ReadonlyArray<{ price: string | number }>,
  rowIndex: number,
  parentName: string
): string => {
  const baseName = getOptionName(ledgerRows[rowIndex].price, parentName);
  const occurrence = ledgerRows
    .slice(0, rowIndex + 1)
    .filter(row => getOptionName(row.price, parentName) === baseName).length;

  if (occurrence === 1) {
    return baseName;
  }

  // Keep the discriminator in the strike token because virtual columns remove that token to recover the group name.
  const separatorIndex = baseName.indexOf(' ');
  return `${baseName.slice(0, separatorIndex)}#${occurrence}${baseName.slice(separatorIndex)}`;
};

export default getOptionName;
